import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FlexBox, FlexItem } from '@codex/basics';
import { Icon } from '@codex/icons';

export const BoxIcon = styled(Icon)`
  display: inline-block;
  width: 31px;
  height: 27px;
  margin: 0 5px 10px 0;
  color: ${props => props.theme.colors.shades[2]};
`;

export const Heading = styled.h2`
  display: inline-block;
  margin: 0 5px 5px 0;
  font-size: 14px;
  
  b {
    color: ${props => props.theme.colors.price.default}
  }
  
  @media ${props => props.theme.breakpoints.desktop} {
    font-size: 14px;
  }
`;

export const Sale = styled.div`
  display: inline-block;
  padding: 7px 10px 6px;
  background-color: ${props => props.theme.colors.price.default};
  color: ${props => props.theme.colors.shades[7]};
  font-size: 16px;
  font-weight: bold;
  
  @media ${props => props.theme.breakpoints.mobile} {
    font-size: 12px;
    padding: 4px 6px;
  }
`;

const BundleHeader = props => (
  <FlexBox>
    <FlexItem>
      <BoxIcon icon="Bundle" size="normal" />
    </FlexItem>

    <FlexItem grow={1} basis="30%">
      <Heading>{props.children}</Heading>
    </FlexItem>

    {props.discountLabel && (
      <FlexItem alignSelf="flex-end">
        <Sale>{props.discountLabel}</Sale>
      </FlexItem>
    )}
  </FlexBox>
);

BundleHeader.propTypes = {
  children: PropTypes.node,
  discountLabel: PropTypes.string
};

BundleHeader.defaultProps = {
  children: undefined,
  discountLabel: ''
};

export default BundleHeader;
